<div class="ws-checkbox"
     (click)="clickDivHandler($event)"
     [dwsPermission]="permission"
     dwsPermissionDenyMode="disable">
  <div class="left-content" #leftContent>
    <ng-content select="[left]"></ng-content>
  </div>

  <div class="checkbox-container">
    <mat-checkbox
      #checkBox
      *ngIf="!loading"
      [checked]="checked"
      [disabled]="disabled"
    ></mat-checkbox>

    <mat-spinner
      *ngIf="loading"
      diameter="15"
      style="display: inline-block"
    ></mat-spinner>
  </div>

  <div class="right-content" #rightContent>
    <ng-content select="[right]"></ng-content>
  </div>
</div>
